<template>
	<div class="home">


		<aside class="left">
			<div class="aside-container-sticky">

				<div class="aside-content">
					<div class="aside-content-header theme-color-4">
						<div class="aside-content-background theme-bg-4"></div>
						Funções
					</div>
					<div class="aside-content-body">
						<div class="aside-content-background theme-bg-3"></div>

						<div class="categories-list hand">
							<div class="categories-list-wrapper">
								<div class="categories-list-toggle"></div>
								<CategoriesList />
							</div>
						</div>

						<div class="options-content hand" @click="newCategory" title="Adicionar nova categoria para seus links">
								<span>+</span>
						</div>

						<div class="preferences hand">
								<ConfigDesktop />
						</div>


						<div v-if="isChrome" class="chrome-extension-link hand" title="Torne o U.R.Links a sua página inicial com apenas 2 cliques! Clique na estrela e, em seguida, clique no botão “Usar/adicionar ao Chrome” (na Chrome Store). É grátis!">
								<a href="https://chrome.google.com/webstore/detail/urlinx/ojfpmgadmbmenaaecebgdgpghiakhefk" target="_blank">
									<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 24 24"><path d="M16.23,18L12,15.45L7.77,18L8.89,13.19L5.16,9.96L10.08,9.54L12,5L13.92,9.53L18.84,9.95L15.11,13.18L16.23,18M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" /></svg>						
								</a>
						</div>


					</div>
				</div>


				<div class="aside-content clock">
					<div class="aside-content-body">
						<div class="aside-content-background theme-bg-4"></div>
						<Clock />
					</div>
				</div>
<!--
				<div class="aside-content options-content hand">
					<div class="aside-content-body">
						<img src="">
					</div>
				</div>
-->
				<!-- <button @click="gridlinks">gridlinks</button> -->


				<div class="aside-content widgets-content">
					<div class="aside-content-header theme-color-4">
						<div class="aside-content-background theme-bg-4"></div>
						Widgets
					</div>
					<div class="aside-content-body">
						<div class="aside-content-background theme-bg-3"></div>
						<Widgets />


					</div>
				</div>

				<div class="aside-content suggested-icons">
					<div class="aside-content-header theme-color-4">
						<div class="aside-content-background theme-bg-4"></div>
						Sugeridos
					</div>
					<div class="aside-content-body">
						<div class="aside-content-background theme-bg-3"></div>
						<div class="links-container">

							<div class="link-item" @click="formAnuncie">
								<a title="Anuncie Aqui">
									<span class="favicon"><p>Anuncie Aqui</p></span>
									<ins></ins>
								</a>
							</div>

							<Sugeridos />

						</div>
					</div>
				</div>
			</div>

		</aside>

		<aside class="right">

			<div class="aside-container-sticky">

<!--
				<div class="aside-content aside-content-config">
					<div class="aside-content-body theme-bg-4 theme-color-4">
							<ConfigDesktop />
					</div>
				</div>
 -->
				<div class="aside-content tasks-content">
					<div class="aside-content-header theme-color-4">
						<div class="aside-content-background theme-bg-4"></div>
						<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 47 47" xml:space="preserve"><g><path d="M6.12,38.52V5.136h26.962v28.037l5.137-4.243V2.568C38.219,1.15,37.07,0,35.652,0h-32.1C2.134,0,0.985,1.15,0.985,2.568 v38.519c0,1.418,1.149,2.568,2.567,2.568h22.408L22.33,38.52H6.12z"/><path d="M45.613,27.609c-0.473-0.446-1.2-0.467-1.698-0.057l-11.778,9.734l-7.849-4.709c-0.521-0.312-1.188-0.219-1.603,0.229 c-0.412,0.444-0.457,1.117-0.106,1.613l8.506,12.037c0.238,0.337,0.625,0.539,1.037,0.543c0.004,0,0.008,0,0.012,0 c0.408,0,0.793-0.193,1.035-0.525l12.6-17.173C46.149,28.78,46.084,28.055,45.613,27.609z"/><path d="M27.306,8.988H11.897c-1.418,0-2.567,1.15-2.567,2.568s1.149,2.568,2.567,2.568h15.408c1.418,0,2.566-1.15,2.566-2.568 S28.724,8.988,27.306,8.988z"/><path d="M27.306,16.691H11.897c-1.418,0-2.567,1.15-2.567,2.568s1.149,2.568,2.567,2.568h15.408c1.418,0,2.566-1.149,2.566-2.568 C29.874,17.841,28.724,16.691,27.306,16.691z"/><path d="M27.306,24.395H11.897c-1.418,0-2.567,1.15-2.567,2.568s1.149,2.568,2.567,2.568h15.408c1.418,0,2.566-1.15,2.566-2.568 C29.874,25.545,28.724,24.395,27.306,24.395z"/></g></svg>
						Minhas tarefas <a @click.prevent="formTask">+</a>
					</div>
					<div class="aside-content-body">
						<div class="aside-content-background theme-bg-3"></div>

						<Tasks />

					</div>
				</div>

				<div class="aside-content textlinks-content">
					<div class="aside-content-header theme-color-4">
						<div class="aside-content-background theme-bg-4"></div>
						<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512.092 512.092" xml:space="preserve"><g><path d="M312.453,199.601c-6.066-6.102-12.792-11.511-20.053-16.128c-19.232-12.315-41.59-18.859-64.427-18.859 c-31.697-0.059-62.106,12.535-84.48,34.987L34.949,308.23c-22.336,22.379-34.89,52.7-34.91,84.318 c-0.042,65.98,53.41,119.501,119.39,119.543c31.648,0.11,62.029-12.424,84.395-34.816l89.6-89.6 c1.628-1.614,2.537-3.816,2.524-6.108c-0.027-4.713-3.87-8.511-8.583-8.484h-3.413c-18.72,0.066-37.273-3.529-54.613-10.581 c-3.195-1.315-6.867-0.573-9.301,1.877l-64.427,64.512c-20.006,20.006-52.442,20.006-72.448,0 c-20.006-20.006-20.006-52.442,0-72.448l108.971-108.885c19.99-19.965,52.373-19.965,72.363,0 c13.472,12.679,34.486,12.679,47.957,0c5.796-5.801,9.31-13.495,9.899-21.675C322.976,216.108,319.371,206.535,312.453,199.601z"/><path d="M477.061,34.993c-46.657-46.657-122.303-46.657-168.96,0l-89.515,89.429c-2.458,2.47-3.167,6.185-1.792,9.387 c1.359,3.211,4.535,5.272,8.021,5.205h3.157c18.698-0.034,37.221,3.589,54.528,10.667c3.195,1.315,6.867,0.573,9.301-1.877 l64.256-64.171c20.006-20.006,52.442-20.006,72.448,0c20.006,20.006,20.006,52.442,0,72.448l-80.043,79.957l-0.683,0.768 l-27.989,27.819c-19.99,19.965-52.373,19.965-72.363,0c-13.472-12.679-34.486-12.679-47.957,0 c-5.833,5.845-9.35,13.606-9.899,21.845c-0.624,9.775,2.981,19.348,9.899,26.283c9.877,9.919,21.433,18.008,34.133,23.893 c1.792,0.853,3.584,1.536,5.376,2.304c1.792,0.768,3.669,1.365,5.461,2.048c1.792,0.683,3.669,1.28,5.461,1.792l5.035,1.365 c3.413,0.853,6.827,1.536,10.325,2.133c4.214,0.626,8.458,1.025,12.715,1.195h5.973h0.512l5.12-0.597 c1.877-0.085,3.84-0.512,6.059-0.512h2.901l5.888-0.853l2.731-0.512l4.949-1.024h0.939c20.961-5.265,40.101-16.118,55.381-31.403 l108.629-108.629C523.718,157.296,523.718,81.65,477.061,34.993z"/></g></svg>
						Meus Text Links <a @click.prevent="newTextlink">+</a>
					</div>
					<div class="aside-content-body">
						<div class="aside-content-background theme-bg-3"></div>
						<Textlinks />
					</div>
				</div>

			</div>


		</aside>


		<div class="grid">

			<Grid />

		</div>


		<div v-if="showSurveyButton" @click="hideSurvey" class="btn-survey"><a href="https://forms.gle/dp7TEfqakJ6xV4rs6" target="_blank">Dê a sua opinião</a><span>×</span></div>

		</div>
</template>

<style scoped>

	aside.left {position: relative;top:5px;width: 70px;flex-shrink: 0;}
aside.right{position: relative;top:5px;width: 205px;flex-shrink: 0; order: 3;}

.aside-content { margin-bottom:10px; border-radius:8px; box-shadow:0px 0px 5px 3px rgba(0,0,0,0.15); }
.aside-content-header { position:relative; border-radius:8px 8px 0 0; border-bottom:1px solid rgba(255,255,255,.3); padding:5px 10px; font-size:14px; overflow: hidden;}
.aside-content-body { padding:10px;color:#fff; border-radius: 8px; position:relative; }
.aside-content-header + .aside-content-body { border-radius: 0 0 8px 8px; }

/*.widgets-content .aside-content-body { overflow:hidden; }*/
.textlinks-content .aside-content-body { overflow:hidden; }
.tasks-content .aside-content-body { overflow:hidden; }
.suggested-icons .aside-content-body { overflow:hidden; }

.aside-content-background {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: -1;
}

.left .aside-content-header { font-size: 12px;  font-weight: 500;}
.left .aside-content-body .aside-content-background { border-radius: 0 0 8px 8px; }
.left .clock .aside-content-body .aside-content-background { border-radius: 8px; }

.aside-content-header button  {
  cursor: pointer;
  border-radius: 50%;
  border: none;
  background: #fff;
  width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  padding: 0;
  position: absolute;
  right: 5px;
  box-shadow: 1px 1px 2px rgba(0,0,0,.5);
}


.aside-content-header a {
  cursor: pointer;
  line-height: 20px;
  font-size: 24px;
  text-align: center;
  padding: 0;
  position: absolute;
  right: 5px;
  color: inherit;
  width: 24px;
}

.options-content .aside-content-body{ background: #f2f2f2; }
.options-content span{font-size: 40px; font-weight: 300; background: #00b3bc; border-radius: 200px; height: 40px; width: 40px; display: block; line-height: 40px; text-align: center; margin: 5px; }


.chrome-extension-link { }
.chrome-extension-link .aside-content-body{ padding:0; background: #f2f2f2; }
.chrome-extension-link a { padding:10px; display: block;  }
.chrome-extension-link svg{ height: 50px; width: 50px; display: block; }
.chrome-extension-link svg path{ fill:#00b3bc }


.preferences .aside-content-body{ background: #f2f2f2; padding: 0;}
.aside-content.clock  .aside-content-body { padding: 5px; }
.categories-list .aside-content-body {background-color: #f2f2f2;}
.categories-list-wrapper { position: relative; z-index:3; }
.categories-list-toggle {
	padding-bottom: 100%;
	background: url(../../public/images/menu-icon.png) no-repeat center;
	background-size: 40px;
	border-radius:5px;
}

.aside-content-body  .categories-list {background-color: #f2f2f2;  	border-radius:10px; margin-bottom:10px;}
.aside-content-body  .categories-list .categories-list-toggle {
	padding-bottom: 100%;
	background: url(../../public/images/menu-icon.png) no-repeat center;
	background-size: 34px;

}
.aside-content-body .options-content {background-color: #f2f2f2;  	border-radius:10px; padding:8px; margin-bottom:10px;}
.aside-content-body .options-content span{font-size: 39px; font-weight: 400; background: #00b3bc; border-radius: 200px; height: 34px; width: 34px; display: block; line-height: 34px; text-align: center; margin: 0; }
.aside-content-body  .preferences {background-color: #f2f2f2;  	border-radius:10px; margin-bottom:10px; }

.aside-content-body .chrome-extension-link {background-color: #f2f2f2;  	border-radius:10px;  margin-bottom:10px;}
.aside-content-body .chrome-extension-link a { padding:7px; display: block;  }
.aside-content-body .chrome-extension-link svg{ height: 36px; width: 36px; display: block; }

.aside-content-config .aside-content-body { padding:0; }


.textlinks-content .aside-content-header svg {width:15px;height: 15px;display:inline-block;margin-right: 3px; vertical-align: -1px}
.tasks-content .aside-content-header svg {width:15px;height: 15px;display:inline-block;margin-right: 3px; vertical-align: -1px}


</style>

<script>

import Widgets from '@/components/Widgets.vue';
import Clock from '@/components/Clock.vue';
import Sugeridos from '@/components/Sugeridos.vue';
import CategoriesList from '@/components/CategoriesList.vue';
import ConfigDesktop from '@/components/ConfigDesktop.vue';
import Tasks from '@/components/Tasks.vue';
import Textlinks from '@/components/Textlinks.vue';
import Grid from '@/components/Grid.vue';


export default {
	name: 'home',
	components: {
		Widgets,
		Clock,
		Sugeridos,
		CategoriesList,
		ConfigDesktop,
		Tasks,
		Textlinks,
		Grid,
	},
	data() {
		return {
			showSurveyButton:true,
		}
	},
	computed: {

		config(){
			return this.$store.state.config;
		},
		preferences(){
			return this.$store.getters.preferences;
		},

		user() {
			return this.$store.getters.user;
		},
		userId() {
			return this.$store.getters.userId;
		},
		isChrome(){
			return this.$store.getters.isChrome;
		}

	},
	methods:{

		logout() {
			this.$store.dispatch('userSignOut');
		},
		formAnuncie(){
			this.$router.push({name:'formAnuncie'})
		},
		formRegistrar(){
			this.$router.push({name:'formRegistrar'})
		},
		formTask(){
			this.$router.push({name:'formTask'})
		},
		newCategory(){
			this.$router.push({name:'formNewCategory' })
		},
		newTextlink(){
			this.$router.push({name:'formTextlink'})
		},

		hideSurvey(){
			this.showSurveyButton = false;
			this.db.collection('users').doc(this.userId).update({showSurveyButton:false});
		},
		modalAdicionarSiteInicio(){
			this.$router.push({name:'site-inicio'})
		},

	},

	created() {


		if(this.user.showSurveyButton===false){
			this.showSurveyButton = false;
		}

		if(!this.user.skipSiteInicio && this.user.created_at && this.user.created_at < new Date().getTime() - 1000*60*60*24){
			this.modalAdicionarSiteInicio();
		}


	},

};





</script>